import * as React from 'react';
import classnames from 'classnames';
import { Form, Grid, Field } from '@alife/cn-ui';
import Item from './item';
import './index.scss';
import OPButton from '../op-button';
const { Row, Col } = Grid;
export default function OPForm(props) {
    const { className = '', formItemLayout = {}, configs = [], columnNumber = 1, field, searchProps, } = props;
    const newField = Field.useField();
    const innerField = field || newField;
    const avgSpan = 24 / columnNumber;
    const renderSearchButtons = () => {
        const { isRightButton = true, buttons, onSearch, onClear, searchText = '查询', clearText = '重置', span, } = searchProps || {};
        const getSpanNumber = (_span) => _span != null ? Number(_span) : avgSpan;
        const allSpans = configs?.reduce((res, curr) => res + getSpanNumber(curr.span), 0);
        const whiteSpan = 24 - (allSpans % 24) - getSpanNumber(span);
        return (React.createElement(React.Fragment, null,
            isRightButton && React.createElement(Col, { span: whiteSpan }),
            React.createElement(Col, { span: span || avgSpan, style: { paddingLeft: 8, paddingRight: 8 } },
                React.createElement(Form.Item, { className: 'op-form-item', labelAlign: formItemLayout.labelAlign, labelTextAlign: formItemLayout.labelTextAlign, labelCol: formItemLayout.labelCol, wrapperCol: formItemLayout.wrapperCol, colon: formItemLayout.colon, label: React.createElement("div", null) }, Array.isArray(buttons) ? (buttons) : (React.createElement(React.Fragment, null,
                    React.createElement(OPButton, { type: 'primary', size: 'small', onClick: () => {
                            onSearch?.(innerField, innerField.getValues());
                        } }, searchText),
                    React.createElement(OPButton, { type: 'normal', size: 'small', onClick: () => {
                            onClear?.(innerField, innerField.getValues());
                            innerField.reset();
                        } }, clearText)))))));
    };
    return (React.createElement("div", { className: classnames('op-form', className) }, configs?.length ? (React.createElement(Form, { size: 'small', fullWidth: true, field: innerField, ...formItemLayout },
        React.createElement(Row, { wrap: true, gutter: 16 },
            configs.map((item) => {
                return (React.createElement(Col, { span: item.span || avgSpan },
                    React.createElement(Form.Item, { className: 'op-form-item', labelAlign: formItemLayout.labelAlign, labelTextAlign: formItemLayout.labelTextAlign, labelCol: formItemLayout.labelCol, wrapperCol: formItemLayout.wrapperCol, colon: formItemLayout.colon, ...item, ...item.decoratorProps },
                        React.createElement(Item, { ...item, ...item.componentProps }))));
            }),
            searchProps && renderSearchButtons()))) : null));
}
